/**
 * @file Agenda drag source absences component
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { DragSourceAbsencesBaseComponent } from '../drag-source-absences-base/drag-source-absences-base.component';
import { DomainService } from '../../domain.service';
import { ExecutorsService } from '../executors.service';
import { AlertsService } from '../../core/alerts.service';
import { GridService } from '../grid.service';
/** Agenda drag source absences component. */
var AgendaDragSourceAbsencesComponent = /** @class */ (function (_super) {
    tslib_1.__extends(AgendaDragSourceAbsencesComponent, _super);
    /**
     * Constructs AgendaDragSourceAbsencesComponent.
     * @param configurationsService The configuration service to get the configuration of this component.
     * @param router The router to synchronize query parameters with component state.
     */
    function AgendaDragSourceAbsencesComponent(domainService, executorsService, alertsService, gridService) {
        var _this = _super.call(this, domainService, executorsService, alertsService, gridService) || this;
        _this.initiateExecutors();
        return _this;
    }
    return AgendaDragSourceAbsencesComponent;
}(DragSourceAbsencesBaseComponent));
export { AgendaDragSourceAbsencesComponent };
